// Role mutations and authorization failures also refresh mounted route/menu
// checks. The listener lives inside react-admin so it uses the active cache.
export const PORTAL_ACCESS_REFRESH_EVENT = "portal-access-refresh";

export const refreshPortalAccess = (): void => {
  window.dispatchEvent(new Event(PORTAL_ACCESS_REFRESH_EVENT));
};
